import { AuthLayout } from 'views/layouts'

import LoginFormContainer from '../../containers/Forms/Login'

const EvaluatedLogin = () => {
  return (
    <AuthLayout variant="evaluated">
      <LoginFormContainer variant="evaluated" />
    </AuthLayout>
  )
}

export default EvaluatedLogin
